/* eslint-disable import/prefer-default-export */
import isNil from 'lodash/isNil';
import React from 'react';

import styles from './DNDLayout.scss';
import { DraggableItem } from './DraggableItem';
import { ReorderableList } from './ReorderableList';

interface DNDLayoutProps {
  originalItems: {
    id?: string;
    text?: string;
  }[];
  selectedItems: {
    id?: string;
    text?: string;
  }[];
  reorderList: (...args: unknown[]) => unknown;
  firstSelection: (...args: unknown[]) => unknown;
  caption?: string;
}

export class DNDLayout extends React.Component<DNDLayoutProps> {
  constructor(props) {
    super(props);
    this.itemsRefs = {};
  }

  onReorder = (rowIndex, targetIndex) => {
    const { reorderList, firstSelection } = this.props;

    if (!isNil(targetIndex)) {
      const alternative = this.getItems()[rowIndex];

      if (this.isAnswered()) {
        reorderList(alternative.id, targetIndex);
      } else {
        firstSelection(alternative.id, targetIndex);
      }
    }
  };

  getItemWidth(index) {
    const { id } = this.getItems()[index];
    const domEle = this.itemsRefs[id];
    const width = domEle ? domEle.getBoundingClientRect().width : null;
    return width;
  }

  getDragPreview = ({ rowIndex, dropTargetIndex }) => (
    <DraggableItem
      text={this.getItems()[rowIndex].text}
      orderNumber={Number.isInteger(dropTargetIndex) ? dropTargetIndex : rowIndex}
      width={this.getItemWidth(rowIndex)}
      isPreview
    />
  );

  setRef = (id) => (ref) => {
    this.itemsRefs[id] = ref;
  };

  getRef = (id) => this.itemsRefs[id];

  getItems = () => {
    return this.isAnswered() ? this.props.selectedItems : this.props.originalItems;
  };

  isAnswered = () => {
    return !!this.props.selectedItems.length;
  };

  render() {
    return (
      <div className={styles.list_container}>
        <ReorderableList
          getPreview={this.getDragPreview}
          getRef={this.getRef}
          items={this.getItems()}
          onReorder={this.onReorder}
          caption={this.props.caption}>
          {(
            id,
            isDragging,
            isValidDropTarget,
            placeholderHeight,
            rowIndex,
            showDropPlaceholderAbove,
            showDropPlaceholderBellow,
            text
          ) => (
            <DraggableItem
              isValidDropTarget={isValidDropTarget}
              isDragging={isDragging}
              key={id + text}
              orderNumber={this.isAnswered() ? rowIndex : undefined}
              placeholderHeight={placeholderHeight}
              setRef={this.setRef(id)}
              showDropPlaceholderAbove={showDropPlaceholderAbove}
              showDropPlaceholderBellow={showDropPlaceholderBellow}
              text={text}
            />
          )}
        </ReorderableList>
      </div>
    );
  }
}
